import { css } from '@emotion/react';
import { DesignToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_LG } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  max-width: 255px;
`;

export const errorContainer = css`
  display: flex;
  align-items: flex-start;
  width: max-content;

  > span {
    padding-top: 3px;
    margin-right: 4px;
  }
`;

export const error = css`
  color: var(${DesignToken.ContentBasicNegative});
`;

export const verificationCode = css`
  width: auto !important;

  > div {
    display: flex;
    justify-content: center;
    gap: 8px;

    > input {
      font-size: 20px !important;
      font-family: inherit !important;
      color: inherit !important;

      border-radius: 8px !important;
      border: 1px solid var(${DesignToken.BorderBasicPrimary}) !important;
      background: var(${DesignToken.SurfacePrimaryDefault});

      ${MEDIA_MIN_LG} {
        font-size: 24px !important;
      }
    }
  }
`;
